"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useAsyncSitecoreData;
var _react = require("react");
var _content = require("../content");
function useAsyncSitecoreData(id, callback, active = true) {
  const [data, setData] = (0, _react.useState)(null);
  const [error, setError] = (0, _react.useState)(null);
  const [retry, setRetry] = (0, _react.useState)(false);
  const [isLoading, setIsLoading] = (0, _react.useState)(active);
  (0, _react.useEffect)(() => {
    if (retry) {
      setData(null);
      setError(null);
      setRetry(false);
    }
  }, [retry]);
  (0, _react.useEffect)(() => {
    const getData = async () => {
      try {
        const res = await (0, _content.getContentItembyID)(id);
        setData(res);
        // eslint-disable-next-line callback-return
        if (callback) await callback(res);
      } catch (err) {
        setError(err);
      } finally {
        setIsLoading(false);
      }
    };
    if (active && !data && !error) {
      setIsLoading(true);
      getData();
    }
  }, [id, callback, active, data, error]);
  return {
    data,
    isLoading,
    error,
    setRetry
  };
}